export default function datetimepicker($timeout) {
  'ngInject'

  var directive = {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      options: '=?',
      onChange: '&?',
      onClick: '&?',
    },
    template: '<input type="hidden" class="bigdrop" id="couponSelect" style="width:400px;"/>',
    link: link,
  }

  function link($scope, $element, $attrs, ngModel) {
    $scope.$watch('options', function (newValue) {
      var dtp = $element.data('DateTimePicker')
      if (newValue !== undefined) {
        $.map(newValue, function (value, key) {
          dtp[key](value)
        })
      }
    })

    ngModel.$render = function () {
      if (ngModel.$viewValue !== undefined) {
        $element.data('DateTimePicker').date(ngModel.$viewValue)
      }
    }

    $element.on('dp.change', function (e) {
      $timeout(function () {
        $scope.$apply(function () {
          ngModel.$setViewValue(e.date)
        })
        if (typeof $scope.onChange === 'function') {
          $scope.onChange()
        }
      })
    })

    $element.on('click', function () {
      $timeout(function () {
        if (typeof $scope.onClick === 'function') {
          $scope.onClick()
        }
      })
    })

    $element.datetimepicker($scope.options)
    $timeout(function () {
      if (ngModel.$viewValue !== undefined && ngModel.$viewValue !== null) {
        if (!(ngModel.$viewValue instanceof moment)) {
          ngModel.$setViewValue(moment($scope.date))
        }
        $element.data('DateTimePicker').date(ngModel.$viewValue)
      }
    })
  }
}
